import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';

export function getTableColumns() {
  return [
    {
      title: '订单编号',
      key: 'insOrderId',
      width: 190,
      fixed: 'left'
    },
    {
      title: '学生姓名',
      key: 'studentName',
      width: 120,
      fixed: 'left'
    },
    {
      title: '年级班级',
      key: 'gradeClassName',
      width: tableColumnsWidth.type8
    },
    {
      title: '家长手机',
      key: 'parentPhone',
      width: tableColumnsWidth.type8
    },
    {
      title: '学校名称',
      slot: 'schoolName',
      minWidth: tableColumnsWidth.type6
    },
    {
      title: '学期',
      key: 'termName',
      width: tableColumnsWidth.type4
    }, {
      title: '课程商品ID',
      key: 'classroomId',
      width: tableColumnsWidth.type4
    },
    {
      title: '关联课程商品',
      slot: 'classroomName',
      width: tableColumnsWidth.type6
    },
    {
      title: '提供方',
      slot: 'orgName',
      width: tableColumnsWidth.type6
    }, {
      title: '上课时间',
      key: 'classDateBegin',
      width: tableColumnsWidth.type6
    },
    {
      title: '商品价格(元）',
      slot: 'originalFee',
      width: tableColumnsWidth.type8,
      align: 'center'
    },
    {
      title: '优惠金额(元)',
      slot: 'discFee',
      width: tableColumnsWidth.type8,
      align: 'center'
    },
    {
      title: '实收金额(元)',
      slot: 'offerFee',
      width: tableColumnsWidth.type8,
      align: 'center'
    }, {
      title: '课程商品实收金额(元)',
      slot: 'classroomFee',
      width: tableColumnsWidth.type8,
      align: 'center'
    },
    {
      title: '父订单ID',
      slot: 'mainOrderId',
      width: 190
    },
    {
      title: '报名方式',
      slot: 'channelType',
      width: 190
    },
    {
      title: '支付方式',
      slot: 'payType',
      width: 190
    },
    {
      title: '下单时间',
      key: 'createTime',
      width: tableColumnsWidth.type6
    },
    {
      title: '材料费名称',
      slot: 'offerName',
      width: tableColumnsWidth.type6
    },

    {
      title: '商品订单状态',
      slot: 'paySts',
      width: tableColumnsWidth.type8,
      align: 'center'
    },
    {
      title: '退款状态',
      slot: 'refundSts',
      width: tableColumnsWidth.type8,
      align: 'center'
    },
    {
      title: '支付完成时间',
      key: 'payTime',
      width: tableColumnsWidth.type6,
      align: 'center'
    },
    {
      title: '退款金额(元)',
      slot: 'refundAmt',
      width: tableColumnsWidth.type8,
      align: 'center'
    },
    slot('结算状态', 'refundCycleMethod', 100, {
      align: 'center'
    }),
    slot('操作', 'action', 110, {
      fixed: 'right',
      align: 'center'
    })
  ];
}
